import { render } from "./UiTour.vue?vue&type=template&id=4741e073&ts=true"
import script from "./UiTour.vue?vue&type=script&lang=ts"
export * from "./UiTour.vue?vue&type=script&lang=ts"

import "./UiTour.vue?vue&type=style&index=0&id=4741e073&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__